<template>
  <div class="invitation">
    <!-- 头部 -->
    <div class="headBox">
      <span class="font18">员工注册</span>
    </div>
    <!-- 头部 END-->

    <van-form>
      <!-- 基本信息 -->
      <van-row class="ioBox">
        <van-cell-group title="基本信息">
          <van-field
            v-model="shortname"
            type="text"
            name="shortname"
            readonly
            label="公司名称"
            required
          />
          <van-field
            v-model="corpNo"
            type="text"
            name="corpNo"
            label="企业号"
            readonly
            required
          />

          <van-field
            v-model="name"
            type="text"
            name="name"
            label="姓名"
            placeholder="请输入姓名"
            required
            :rules="[{ required: true, message: '请输入姓名' }]"
          />
          <van-field
            v-model="phoneNumber"
            type="text"
            name="phoneNumber"
            label="手机号码"
            placeholder="请输入手机号码"
            required
            :rules="[{ required: true, message: '请输入手机号码' }]"
          />

          <van-field
            v-model="smsCode"
            name="smsCode"
            type="text"
            center
            clearable
            placeholder="请输入短信验证码"
          >
            <template #button>
              <ld-button
                size="sm"
                main2
                @click.native="getRegisterSmsCode"
                :disabled="smsCodeDisabled"
                class="font12"
                style="width:130px;"
              >
                <span v-show="smsCodeDisabled">
                  {{ smsCodeTime }}s后重新获取
                </span>
                <span v-show="smsCodeDisabled==false">获取验证码</span>
              </ld-button>
            </template>
          </van-field>



          <van-field
            v-model="email"
            type="text"
            name="email"
            label="邮箱"
            placeholder="请输入邮箱地址"
          />
        </van-cell-group>
      </van-row>
      <!-- 基本信息 END-->
      <!-- 身份信息 -->
      <van-row class="ioBox">
        <van-cell-group title="身份信息">
          <van-field
            v-model="empNo"
            type="text"
            name="empNo"
            label="员工工号"
            placeholder="请输入员工工号"
          />
          <van-field
            readonly
            clickable
            label="部门"
            :value="deptName"
            placeholder="请选择"
            @click="$refs.department.toggle()"
          />

          <ld-department
            ref="department"
            :corpId="corpId"
            @selected="departmentSelect"
          />

        </van-cell-group>
      </van-row>
      <!-- 身份信息 END-->
      <!-- 证件信息-->
      <van-row class="ioBox">
        <van-cell-group title="证件信息">
          <van-field
            readonly
            clickable
            label="国籍"
            :value="nationName"
            required
            placeholder="请选择"
            @click="$refs.nation.toggle()"
          />
          <ld-nation
            ref="nation"
            @selected="nationSelect"
          />
          <van-field
            v-model="idNumber"
            type="text"
            name="idNumber"
            label="身份证号"
            placeholder="请输入身份证号"
            :error-message="idNumberErrMsg"
          />
          <van-field
            v-model="passport"
            type="text"
            name="passport"
            label="护照号码"
            placeholder="请输入护照号码"
          />
          <van-field
            readonly
            clickable
            name="passportPeriod"
            label="护照有效期"
            :value="passportPeriod"
            :placeholder="!passport?'请输入护照号码':'请选择'"
            @click=" !passport ? passportPeriodShow=false:passportPeriodShow = true"
          />
          <van-popup v-model="passportPeriodShow" round position="bottom">
            <van-datetime-picker
              @confirm="passportPeriodConfirm"
              @cancel="passportPeriodShow = false"
              type="date"
              title="选择年月日"
              :min-date="passportPeriodMinDate"
              :max-date="passportPeriodMaxDate"
            />
          </van-popup>

          <van-field
            readonly
            clickable
            label="签发地"
            :value="placeOfName"
            :placeholder="!passport?'请输入护照号码':'请选择'"
            @click="!passport ? true : $refs.placeOfIssue.toggle()"
          />
          <ld-nation
            ref="placeOfIssue"
            @selected="placeOfIssueSelect"
          />

        </van-cell-group>
      </van-row>
      <!-- 证件信息 END-->


      <!-- 其他信息-->
      <van-row class="ioBox">
        <van-cell-group title="其他信息">
          <van-field
            name="sex"
            label="性别"
            required
          >
            <template #input>
              <van-radio-group v-model="sex" direction="horizontal">
                <van-radio name="F">男</van-radio>
                <van-radio name="M">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            readonly
            clickable
            name="born"
            label="出生日期"
            :value="born"
            placeholder="请选择"
            @click="bornShow = true"
          />
          <van-popup v-model="bornShow" round position="bottom">
            <van-datetime-picker
              @confirm="bornConfirm"
              @cancel="borndShow = false"
              type="date"
              title="选择年月日"
              :min-date="bornMinDate"
              :max-date="bornMaxDate"
            />
          </van-popup>
        </van-cell-group>
      </van-row>

      <van-field name="isCivil" label="您是否是公务员" label-width="7em">
        <template #right-icon>
          <van-switch v-model="isCivil" size="20" />
        </template>
      </van-field>
      <!-- 其他信息 END-->

      <div style="margin: 16px;">
        <ld-button
          @click.native="getCorp"
          class="login_btn"
          main2
          :disabled="(name&&phoneNumber&&sex&&smsCode&&nationName&&!idNumberErrMsg)==false"
          size="lg"
        >
          注册
        </ld-button>
      </div>
    </van-form>


  </div>
</template>

<script>
import VConsole from 'vconsole'
import {Form,Field,Button,Col,Row,Popup,Picker,DatetimePicker,Switch,Radio,RadioGroup,CellGroup,Dialog} from 'vant'
import ldNation from 'Components/ldNation'
import ldDepartment from 'Components/ldDepartment'
import { validators } from 'Utils/valid'

import { trimStrDate } from 'Utils/dateUtil'
import ldButton from 'Common/ldButton'

import { mapGetters } from 'vuex'

import { excludeSpecial } from 'Utils/string'
import { getIDcardInfo } from 'Utils/publicFun'

import { localremove} from 'Utils/storage.js'

export default {
  components: {
    ldNation,
    ldDepartment,
    ldButton,
    [Form.name]: Form,
    [Field.name]:Field,
    [Button.name]:Button,
    [Col.name]:Col,
    [Row.name]:Row,
    [Popup.name]:Popup,
    [Picker.name]:Picker,
    [DatetimePicker.name]:DatetimePicker,
    [Switch.name]:Switch,
    [Radio.name]:Radio,
    [RadioGroup.name]:RadioGroup,
    [CellGroup.name]:CellGroup,
  },
  watch:{
    'idNumber': function(val) {
      this.idNumber=excludeSpecial(val)
      if (val && !validators['is-idCard'](val).valid) {
        this.idNumberErrMsg = validators['is-idCard'](val).msg
      } else {
        this.idNumberErrMsg = ''
      }
      if(!this.born&&this.idNumber&&!this.idNumberErrMsg){
        this.born=getIDcardInfo(this.idNumber).born
      }
    },
    'passport':function(){
      if(!this.passport){
        this.passportPeriod=''
        this.placeOfName=''
        this.placeOfIssue=''
      }
    }
  },
  data() {
    return {
      /* 基本信息 */
      corpId:'', // (string): 企业ID ,
      shortname:'', // (string): 企业名称,
      corpNo:'', // (string, optional): 企业编号
      name:'', // (string): 姓名 ,
      phoneNumber:'', // (string): 手机号码 ,
      smsCodeDisabled:false,
      smsCode:'',//验证码
      smsCodeTime:0,//验证码计时
      email:'', // (string, optional): 邮箱 ,
      /* 基本信息 END*/
      /* 身份信息 */
      empNo:'', // (string): 员工工号 ,
      deptId:'', // (string): 当前所属部门ID ,
      deptName:'', // (string): 当前所属部门名称 ,
      /* 身份信息 END*/
      /* 证件信息 */
      nationId:'00002', // (string): 国籍 ,
      nationName:'中国', // (string): 国籍 ,
      idNumber:'', // (string, optional): 身份证号 ,
      idNumberErrMsg:'',//身份证验证
      passport:'', // (string, optional): 护照号码 ,
      passportPeriod:'', // (string, optional): 护照有效期 ,
      passportPeriodShow:false,
      passportPeriodMinDate: new Date(),
      passportPeriodMaxDate: new Date(2050, 10, 1),
      placeOfName:'', // 签发地名称
      placeOfIssue:'', // (string, optional): 证件签发地 ,
      /* 证件信息 END*/
      /* 其他信息 */
      sex:'F', // (string): 性别F男，M女 ,
      born:'', // (string, optional): 出生年月YYYY ,
      bornShow:false,
      bornMinDate: new Date(1950, 0, 1),
      bornMaxDate: new Date(),
      isCivil:false, // (integer, optional): 是否公务员 1是0否 默认0 ,
      /* 其他信息 END*/

      allotType:'1'
    }
  },
  created(){
    const data = JSON.parse(this.$route.query.data)
    const {corpId,shortname,corpNo} = data
    this.corpId = corpId
    this.shortname = shortname
    this.corpNo = corpNo
  },
  mounted() {

  },
  methods: {
    newConsole() {
      new VConsole()
    },

    getCorp() {
      const {
        name,
        phoneNumber,
        email,
        empNo,
        deptId,
        nation,
        idNumber,
        passport,
        passportPeriod,
        placeOfIssue,
        sex,
        born,
        isCivil,
        corpId,
        corpNo,
        smsCode
      } = this
      let data = {
        name,
        phoneNumber,
        email,
        empNo,
        deptId,
        nation,
        idNumber,
        passport,
        passportPeriod,
        placeOfIssue,
        sex,
        born,
        isCivil,
        corpId,
        corpNo,
        smsCode
      }
      if (!empNo) {
        data.empNo = data.phoneNumber
      }
      if (data.isCivil) {
        data.isCivil = 1
      } else {
        data.isCivil = 0
      }

      if (!deptId) {
        const nationList = this.$refs.department.nationList || []
        nationList.forEach(element => {
          if (!element.parentId || element.parentId == 0) {
            data.deptId = element.id
          }
        });
      }

      if (!data.idNumber && !data.passport) {
        this.$toast('身份证或护照必填一项！')
      } else {
        if (this.idNumberErrMsg !== '') {
          return
        } else {
          this.$api['user/userRegisterForQr'](data).then(res => {
            if (res.errCode == '1') {
              Dialog.alert({
                message: res.data,
              }).then(() => {
                localremove('AutoLogin')
                localremove('access_token')
                this.$router.push({path: '/login'})
              });
            }
          })
        }
      }
    },
    departmentSelect (department) { //部门
      this.deptId = department.id
      this.deptName = department.label
    },

    nationSelect (nation) { //国家
      this.nationName = nation.cName
      this.nation = nation.id
    },
    placeOfIssueSelect (nation){ //签证
      this.placeOfName = nation.cName
      this.placeOfIssue = nation.id
    },
    passportPeriodConfirm(time) { // 证件有效期
      this.passportPeriod = trimStrDate(time)
      this.passportPeriodShow = false;
    },
    bornConfirm(time) { // 出生年月日
      this.born = trimStrDate(time)
      this.bornShow = false;
    },
    // 获取短信验证码
    async getRegisterSmsCode(){
      if(this.phoneNumber){
        var reg = /^1[3456789]\d{9}$/
        if(reg.test(this.phoneNumber)){

          let param = {
            corpId: this.corpId,
            corpNo: this.corpNo,
            phoneNumber: this.phoneNumber.trim(),
          }

          await this.$api['user/getRegisterSmsCode'](param)
          this.smsCodeDisabled=true
          this.smsCodeTime='60'
          var time=setInterval(() => {
            this.smsCodeTime-=1
            if(this.smsCodeTime==0||this.smsCodeTime<=0){
              this.smsCodeDisabled=false
              clearInterval(time)
            }
          },1000)
        }else{
          this.$toast('手机号码有误')
        }
      }else{
        this.$toast('请先输入手机号！')
      }
    },
  },
  computed:{
    ...mapGetters({
      loginConfig:'loginConfig'
    })
  }
}
</script>

<style lang="less" scoped>
.invitation {
  color: @color-text-black;
  background-color: #f1f1f1;
  .headBox{
    width: 100%;
    text-align: center;
    height: 60px;
    line-height: 60px;
    background-color: @color-text-white;
  }

}
</style>
